import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function EmailContentPreview() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const body = state?.body;
  const subject = state?.subject;

  return (
    <div className="border-2 border-light rounded-xl p-4">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <p className="text-[#2F2B3D] text-xl font-semibold m-0">Email Content Preview</p>
      </div>

      <div className="mb-3">
        <span className="text-sm text-gray-600 font-medium">Subject: </span>
        <span className="text-sm text-gray-900">{subject || '--'}</span>
      </div>

      <div className="border border-light rounded-lg p-4 max-h-[70vh] overflow-auto pointer-events-none">
        {body ? (
          <div dangerouslySetInnerHTML={{ __html: body }} />
        ) : (
          <div className="text-sm text-gray-500">--</div>
        )}
      </div>
    </div>
  );
}

